<script lang="ts">
  import {onMount} from "svelte"
  import * as ErrorStackParser from "error-stack-parser"

  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher<{highlight:{startRow:number, startColumn:number, endRow:number, endColumn:number}}>()

  export let error:Error
  $: stackFrames = ErrorStackParser.parse(error);
  $: errorType = error.constructor ? error.constructor.name : typeof error;

  onMount(()=>{
    onClick(0)
  });

  function onClick(index:number) {
    let row:number|undefined = stackFrames[index]?.lineNumber
    if (row != undefined) {
      let column:number|undefined = stackFrames[index].columnNumber
      if (column == undefined) {
        dispatch("highlight", {startRow:row-1, startColumn:-1, endRow:row-1, endColumn:Number.MAX_SAFE_INTEGER});
      }
      else {
        dispatch("highlight", {startRow:row-1, startColumn:column, endRow:row-1, endColumn:column+1});
      }
    }
  }
</script>

<div class="text-darkFore bg-darkBack">
  <div><span class="text-red">⦻ Exception </span>{errorType + ": " + error.message}</div>
  {#each stackFrames as stackFrame,index}
  <div>&nbsp;&nbsp;{"at " + stackFrame.functionName + " ("}<button class="text-blue underline" on:click={()=>onClick(index)}>{stackFrame.fileName + ":" + stackFrame.lineNumber + ":" + stackFrame.columnNumber}</button>)</div>
  {/each}
</div>
